<mat-progress-bar mode="indeterminate" color="accent" *ngIf="isShow"></mat-progress-bar>
<div class="m-25">
  <div fxLayoutAlign="space-between start">
    <mat-card-title>Upload Documents</mat-card-title>
    <div class="pointer" (click)="onClose()">
      <mat-icon>clear</mat-icon>
    </div>
  </div>
  <section id="file-upload">
    <div fxLayout="row wrap" class="m-b-20">
      <div fxFlex="100">
        <div ng2FileDrop [ngClass]="{ 'nv-file-over': hasBaseDropZoneOver }" (fileOver)="fileOverBase($event)"
          [uploader]="uploader" class="text-center my-drop-zone">
          <div>Drag your documents here</div>
          <input type="file" accept=".xlsx,.xls,image/*,.doc, .docx,.txt,.pdf" ng2FileSelect [uploader]="uploader" id="selectedFile"
            style="display: none;" multiple />
          <button class="m-b-20" color="primary" (click)="onClickUploadFile($event)" mat-raised-button>
            <mat-icon>insert_drive_file</mat-icon>
            Select documents
          </button>
        </div>
      </div>
    </div>
    <div fxLayout="row wrap" class="m-b-20" *ngIf="fileUploadError">
      <div class="fileError">{{ fileUploadError }}</div>
    </div>
    <div fxLayout="row wrap" class="m-b-10" *ngIf="uploader.queue.length">
      <div fxFlex="100">
        <table class="table">
          <thead>
            <tr>
              <th width="90%">File name</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of uploader.queue">
              <td>
                <div>{{ item?.file?.name }}</div>
              </td>
              <td nowrap>
                <div class="pointer" (click)="item.remove()">
                  <mat-icon color="warn">delete</mat-icon>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div fxLayout="row wrap">
      <button type="button" class="m-r-10" mat-raised-button color="primary" (click)="uploadDocuments()"
        [disabled]="!uploader.getNotUploadedItems().length">
        <mat-icon>cloud_upload</mat-icon> Upload all
      </button>
      <button type="button" mat-raised-button color="warn" (click)="uploader.clearQueue()"
        [disabled]="!uploader.queue.length">
        <mat-icon>delete</mat-icon> Remove all
      </button>
    </div>
  </section>
</div>